var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-image-visual-id"},[_c('div',{staticClass:"banner-image",style:({ backgroundImage: `url(${_vm.bannerImageSrc})` })}),_c('div',{staticClass:"overlay-image"},[_c('h1',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.bannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }